// extracted by mini-css-extract-plugin
export var compact = "_mv-2";
export var phoneFrame = "_mv-0";
export var phoneScreen = "_mv-1";